import requests from 'legacy/utils/requests'

const BASE_URL = '/api/v2/loadboard'

export function acceptBid(bidUUID, data) {
  return requests.post(
    `${BASE_URL}/bids/${bidUUID}/accept`,
    JSON.stringify({ ...data, channel: 'carrier' })
  )
}

export function deleteBid(bidUUID) {
  return requests.delete(`${BASE_URL}/bids/${bidUUID}`)
}

export function getBids() {
  return requests.get(`${BASE_URL}/bids`)
}

export function counterBid(bidUUID, data) {
  return requests.post(`${BASE_URL}/bids/${bidUUID}/counter`, data)
}

export function refuseBid(bidUUID, reason) {
  return requests.post(`${BASE_URL}/bids/${bidUUID}/refuse`, { reason_note: reason })
}
